module.exports = __webpack_public_path__ + "img/fb.d30eff51.svg";